// Named icon map for data-driven icons (content.js `icon: "Name"`).
// Importing `* as Icons from "lucide-react"` pulls the whole icon library
// (1,500+ icons) into the bundle; list only what the site uses here.
import {
  ArrowRight, Banknote, Briefcase, CheckCircle2, ClipboardList, Clock, Facebook,
  FileCheck2, FileSpreadsheet, Fingerprint, FolderCheck, HandCoins,
  HeartPulse, IdCard, Instagram, Link, Linkedin, MapPin, MonitorCheck,
  ReceiptText, Search, SearchCheck, Send, ShieldCheck, UserCheck, Users,
} from "lucide-react";

export const Icons = {
  ArrowRight, Banknote, Briefcase, CheckCircle2, ClipboardList, Clock, Facebook,
  FileCheck2, FileSpreadsheet, Fingerprint, FolderCheck, HandCoins,
  HeartPulse, IdCard, Instagram, Link, Linkedin, MapPin, MonitorCheck,
  ReceiptText, Search, SearchCheck, Send, ShieldCheck, UserCheck, Users,
};
